export const PUBLIC_HEALTH_POLICY_CODE = 'PUBLIC_HEALTH_POLICY'

// The HTTP client keys its persistent cache by URL, not Axios params.
export const PUBLIC_HEALTH_POLICY_URL =
  `/core/config/search?searchKey=${PUBLIC_HEALTH_POLICY_CODE}&page=1&perPage=100`
